<template>
  <div :class="classNames">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      label-position="top"
    >
        <el-form-item label="商品名称" prop="goods_name" label-position="left">
            <div :class="classNames + '_from_item_con'">
                <div :class="classNames + '_disabled'"></div>
                <el-input v-model="ruleForm.goods_name" placeholder="请输入商品名称"/>
            </div>
        </el-form-item>
        <el-form-item label="商品图片" prop="goods_img" label-position="left">
            <template slot="label">
                <span>商品图片</span>
                <el-popover
                placement="right-end"
                trigger="hover"
                >
                <img src="@/assets/image/relation1.png"/>
                <span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
                </el-popover>
            </template>
            <div :class="classNames + '_from_item_con'">
                <uploader-img size="110*130" v-model="ruleForm.goods_img" cropperW="220" cropperH="260" :ratio="[11,13]" boxW="110" boxH="130"></uploader-img>
            </div>
        </el-form-item>
        <el-form-item label="商品口令" prop="goods_share_text" label-position="left">
            <template slot="label">
                <span>商品口令</span>
                <el-popover
                placement="right-end"
                trigger="hover"
                >
                <video src="https://doubaosrc.doutuimao.net/teacherpc/reation.mp4" controls style="max-height:80vh;width:100%"/>
                <span slot="reference" :class="classNames + '_from_item_tit'" style="color: #1989FA;text-decoration: underline;">查看示例</span>
                </el-popover>
            </template>
            <div :class="classNames + '_from_item_con'">
                <div :class="classNames + '_disabled'" ></div>
                <el-input v-model="ruleForm.goods_share_text" placeholder="请输入商品口令"/>
            </div>
        </el-form-item>
      <el-form-item label="参与课程" prop="class" label-position="left">
        <div :class="classNames + '_from_item_con'">
            <div :class="classNames + '_disabled'" ></div>
            <div :class="classNames+'_add_class'">
              <el-button type="primary" @click="addClass">添加课程</el-button>
            </div>
            <!-- <p style="color:#606266">提示：一个课程只能参加一个抢购活动</p> -->
            <join-relation v-model="joinFlag" @sure="sure"></join-relation>
        </div>
      </el-form-item>
      <el-form-item v-if="ruleForm.class">
        <div :class="classNames+'_add_con'">
          <p :class="classNames+'_tit'">关联课程</p>
          <div :class="classNames+'_add_class_info'">
            <div :class="classNames+'_add_class_left'">
              <img :src="ruleForm.class.img" alt=""/>
            </div>
            <div :class="classNames+'_add_class_center'">{{ruleForm.class.title}}</div>
            <div :class="classNames+'_add_class_right'" @click="joinFlag = true">添加课程</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label-position="left">
        <span style="font-size: 14px;color: #606266;margin-right: 12px">是否购买后展示</span>
      <el-switch
        v-model="is_buy">
      </el-switch>
      </el-form-item>
      <el-form-item>
        <div :class="[classNames + '_operat', classNames + '_from_item_con']">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button type="primary" @click="goBack">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import uploaderImg from '@/components/upload/upload.vue'
import JoinRelatio from './joinRelation.vue'
export default {
  name: "CreateChapter",
  data() {
    return {
      classNames: "CreateChapter",
      ruleForm: {
        class: '',
        goods_name: '',
        goods_img: '',
        goods_share_text: '',
        product_id: '',
        show_id: '',
      },
      is_buy: 0,
      rules: {
        class: [
          {
            required: true,
            message: "添加课程",
            trigger: "none",
          },
        ],
        goods_name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
        ],
        goods_img: [
          {
            required: true,
            message: "请上传商品图片",
            trigger: "change",
          },
        ],
        goods_share_text: [
          {
            required: true,
            message: "请输入抖音小店商品口令",
            trigger: "blur",
          },
        ],
      },
      joinFlag: false
    };
  },
  components: {
      'uploader-img': uploaderImg,
      'join-relation': JoinRelatio
  },
  created() {
  },
  computed: {
    ...mapState(["breadCrumbList"]),
  },
  methods: {
    ...mapActions("relation", ["relationAdd"]),
    async saveDraft() {
      this.$message({
        type: "success",
        message: "保存成功",
      });
    },
    handleVirPuCh() {
        this.ruleForm.price = this.ruleForm.price.replace(/[^0-9.]/g, '')
        if (this.ruleForm.price.indexOf('.') > 0) {
            this.ruleForm.price = this.ruleForm.price.slice(0, this.ruleForm.price.indexOf('.') + 3)
        }
    },
    handleSort(value) {
      this.ruleForm.person = this.ruleForm.person.replace(/[^0-9]/g, "");
    },
    sure(value, value1) {
        this.ruleForm.class = value
        this.ruleForm.product_id = value.id
        this.ruleForm.show_id = value1.id || ''
    },
    addClass() {
        this.joinFlag = true
    },
    goBack() {
        this.$router.go(-1)
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
        	let params = JSON.parse(JSON.stringify(this.ruleForm))
          if(params.class) {
            delete params.class
          }
        	try {
                let res = await this.relationAdd({
                  ...params,
                  is_buy: this.is_buy? 2: 1
                })
                this.$message({
        			type: 'success',
        			message: '提交成功'
        		})
                this.$router.go(-1)
                } catch (error) {
                    
                }
        } else {
        	console.log('error submit!!');
        	this.$message.closeAll()
        	this.messageOption = this.$message({
        		message: '有必填项没有填写或格式错误',
        		showClose: true,
        		duration: 0,
        		type: 'error'
        	})
        	return false;
        }
      });
    },
  },
  watch: {},
  beforeDestroy() {
    if (this.messageOption) {
      this.messageOption.close();
    }
    this.messageOption = "";
  },
};
</script>
<style lang="less">
@classNames: CreateChapter;
.market_date_picker {
    .el-picker-panel__footer {
        display: flex;
        justify-content: space-between;
        padding-left: 16px;
        padding-right: 16px;
        .el-button {
            &:nth-child(2) {
                background-color: #409eff;
                border-color: #409eff;
                color: #fff;
            }
            &.is-disabled {
                background-color: #fff;
                border-color: #ebeef5;
                color: #c0c4cc;
            }
        }
    }
}
</style>
<style lang="less" scoped>
@classNames: CreateChapter;
.@{classNames} {
  max-width: 660px;
  // margin: 0 auto;
  // position: relative;
  .@{classNames}_from_item_con {
    width: 660px;
    display: inline-block;
    position: relative;
  }
}
.@{classNames}_from_item_tit {
  margin-left: 20px;
}
.@{classNames}_operat {
  display: flex !important;
  justify-content: flex-end;
}
.@{classNames}_class_content {
  .@{classNames}_radio {
    display: flex;
    flex-direction: column;
    position: relative;
    left: 20px;

    .el-radio {
      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}
.@{classNames}_add_con {
  .@{classNames}_tit {
    font-size: 14px;
    color: #37383c;
    line-height: 20px;
    margin-bottom: 10px;
    font-weight: 550;
  }
  .@{classNames}_add_class_info {
    width: 660px;
    height: 80px;
    background: #f8f9fb;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .@{classNames}_add_class_left {
      width: 60px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .@{classNames}_add_class_center {
      width: 410px;
      height: 100%;
      color: #6a6c76;
      word-break: break-all;
      line-height: normal;
    }
    .@{classNames}_add_class_right {
      font-size: 14px;
      line-height: 20px;
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>
